import React from 'react';
export function EmailOpenIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.147 7.403L13 1h-2L1.853 7.403A2 2 0 001 9.04V21a2 2 0 002 2h18a2 2 0 002-2V9.041a2 2 0 00-.853-1.638zM21 20.938V21H3v-.062l5.545-5.119L11.135 18h1.73l2.59-2.18L21 20.937zm0-2.722v-7.067l-4.003 3.372L21 18.216zM3 11.149v7.067l4.003-3.695L3 11.149zm17.672-2.338L12.369 3h-.739L3.328 8.811 11.865 16h.27l8.537-7.189z"
  }));
}